import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Logger } from 'src/app/core/logger';
import { WidgetsFieldModel } from 'src/app/models/widgets/widgets-field.model';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';

@Component({
  selector: 'app-metadata-builtin-field',
  templateUrl: './metadata-builtin-field.component.html',
  styleUrls: ['./metadata-builtin-field.component.scss']
})
export class MetadataBuiltinFieldComponent implements OnInit {
  @Input() data: WidgetsFieldModel = new WidgetsFieldModel();

  nextValue: number = 0;
  errorMessage: string = "";
  // form: FormGroup = this.fb.group({
  //    label: ['', Validators.maxLength(this.headerLength)],
  //    description: ['', Validators.maxLength(this.headerLength)],
  //    options: this.fb.array([])
  //  });
  constructor(
    // private fb: FormBuilder,
    public cd: ChangeDetectorRef,
    private widgetsService: WidgetsService,
    private logger: Logger,
    ) {
      // this.form = this.fb.group({
      //   label: [this.data.label, Validators.maxLength(this.headerLength)],
      //   description: [this.data.description, Validators.maxLength(this.headerLength)],
      //   options: this.fb.array([])
      // });
    }

  ngOnInit(): void {
    // this.form = this.fb.group({
    //   label: [this.data.label, Validators.maxLength(this.headerLength)],
    //   description: [this.data.description, Validators.maxLength(this.headerLength)],
    //   options: this.fb.array([])
    // });
  }

  onTypeSelected($event: any) {
    this.data.key = this.widgetsService.getNextKey(this.data.type);
  }
}
